/* Set the initial sort through Judge.me's own control; never filter reviews. */
(() => {
  const widget = document.getElementById('judgeme_product_reviews');
  if (!widget || widget.dataset.zuofunSortReady) return;
  widget.dataset.zuofunSortReady = 'true';
  let finished = false;
  let observer;
  const stop = () => {
    finished = true;
    observer?.disconnect();
    widget.removeEventListener('change', onUserChange, true);
  };
  const onUserChange = (event) => {
    if (event.isTrusted && event.target.matches('.jdgm-sort-dropdown')) stop();
  };
  const initialize = () => {
    if (finished) return;
    const select = widget.querySelector('.jdgm-sort-dropdown');
    if (!select || !select.querySelector('option[value="highest_rating"]')) return;
    stop();
    if (select.value !== 'highest_rating') {
      select.value = 'highest_rating';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  widget.addEventListener('change', onUserChange, true);
  observer = new MutationObserver(initialize);
  observer.observe(widget, { childList: true, subtree: true });
  initialize();
  // Do not keep observing indefinitely if the third-party widget fails to load.
  setTimeout(stop, 30000);
})();
